import React from 'react';
import { motion } from 'framer-motion';
const COSTS = ['3 horas de planificación por semana × 40 semanas = 120 horas de tu vida', 'Evaluaciones sin rúbrica × 30 alumnos × 3 trimestres = domingos perdidos', 'Material de Portugal que confunde al alumno argentino', 'Falsos amigos sin contexto = errores que se fijan para siempre', 'Clases sin oralidad porque da miedo implementarla', 'Alumnos que se pierden y no vuelven al portugués', 'Clases improvisadas que no enganchan', 'El domingo de la semana que viene, igual que este.'];
export function CostOfInaction() {
  return <section className="w-full bg-light-gray py-20 px-4" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-3xl font-bold text-deep-green mb-4" data-id="element-43">
            🇧🇷 PORTUGUÉS 360™
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-500 mb-8" data-id="element-44">
            El próximo domingo podés seguir buscando material en Google.
            <br className="hidden md:block" data-id="element-45" />O podés tener todo resuelto desde
            hoy.
          </motion.p>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl font-bold text-deep-green" data-id="element-46">
            ¿Cuánto cuesta realmente NO tenerlo?
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 max-w-3xl mx-auto" data-id="element-47">
          {COSTS.map((cost, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-48">
              <span className="text-red-500 mt-1.5 flex-shrink-0 text-xs" data-id="element-49">
                ●
              </span>
              <p className="text-gray-700 text-sm font-medium leading-relaxed" data-id="element-50">
                {cost}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}